var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config"},[_c('div',[_vm._v("\n    PA v."+_vm._s(_vm.serverConfig.api_version)+"\n    // db"+_vm._s(_vm.serverConfig.db_version)+"\n    // @"+_vm._s(_vm.serverConfig.spooled_at)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67735a12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config.vue
// module id = 1211
// module chunks = 1